import React, { useState } from "react";

const EligibilityYEI = () => {
  const [activeSection, setActiveSection] = useState(null);

  const handleToggle = (sectionId) => {
    setActiveSection(activeSection === sectionId ? null : sectionId);
  };

  const sections = [
    {
      id: 1,
      title: "Eligibility",
      content: `Direct Entry Route:
Applicants must meet the following criteria:

- Academic Qualifications: Hold a recognised Bachelor’s degree or equivalent qualification
from an accredited institution.
- Interest in Diplomacy and International Relations: Demonstrate a strong passion for
diplomacy &amp; international relations and a commitment to fostering innovation and positive
change.
`,
    },
    {
      id: 2,
      title: "IT Requirements",
      content: `The course material will be delivered, & the learning objectives achieved through video-based teaching platforms & a specialised course Virtual Learning Environment (VLE). Therefore, you will require access to:
  
  - the internet via a computer, laptop, tablet, or other smart device
  - speakers or headphones to listen to any pre-recorded material or videos
  - a webcam & microphone for any interactive sessions that may be available`,
    },
    {
      id: 3,
      title: "Identity Check",
      content: `As part of your application, you will be required to provide a copy of your ID. At the beginning of the course, you will be required to attend a live zoom session, so that we can verify your identity.`,
    },
    {
      id: 4,
      title: "English Language Proficiency",
      content: `Applicants must meet the following proficiency criteria:
      
- TOEFL (213 computer-based, 79/93 internet-based, or 550 paper-based)
- IELTS (Minimum score: 5.5)

- Cambridge ESOL (CAE, Minimum score: C1)
- Formal education conducted in English or equivalent qualifications.`,
    },
  ];

  return (
    <div className="md:scroll-mt-44 scroll-mt-16 my-10" id="eligibility">
      <div className="bg-sddarkgray py-3">
        <div className="max-w-6xl mx-auto px-3 space-y-5">
          <h2 className="text-xl font-bold mb-4 text-gray-50">
            Eligibility & Requirements
          </h2>
          <div className="bg-gray-50 h-1 w-14 "></div>
          <div className="space-y-1">
            {sections.map((section) => (
              <div key={section.id} className="border-y border-black">
                <button
                  onClick={() => handleToggle(section.id)}
                  className="w-full text-left py-2 px-3 bg-blue-50 hover:bg-blue-100 focus:outline-none"
                >
                  <div className="flex justify-between items-center">
                    <span className="font-medium">{section.title}</span>
                    <span>{activeSection === section.id ? "▲" : "▼"}</span>
                  </div>
                </button>
                {activeSection === section.id && (
                  <div className="px-3 py-2 bg-sdbodywhite border-t border-gray-300">
                    <p className="text-gray-700 whitespace-pre-line">
                      {section.content}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EligibilityYEI;
